var AdaptiveImage = require("../../../../web/node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/loading-spinner-blue-white.8755bea6.png","uri@2x": __webpack_public_path__ + "static/media/loading-spinner-blue-white.f6055e60.png","uri@3x": __webpack_public_path__ + "static/media/loading-spinner-blue-white.65dcff46.png",
    width: 24,
    height: 24
});